import { useQuery } from "@tanstack/react-query";
import DashboardService from "src/apis/DashboardService";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import { useMemo } from "react";
import CategoriesAnalytics from "../../CategoriesAnalytics";

const DashboardCategories = ({ t, filters, modules }) => {
  const { data: dashboardData, isFetching: dataIsFetching } = useQuery({
    queryKey: ["wb-cm-fetch-admin-dashboard-categories-query", filters],
    queryFn: async () => {
      const service = DashboardService.getInstance();
      return await service.fetchCategories(
        {
          ...filters,
          excludeDeleted: (filters.exclude || []).includes("deleted_cases"),
          excludeTestCases: (filters.exclude || []).includes("test_cases"),
          exclude: undefined,
        },
        modules?.active
      );
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  const categories = useMemo(() => {
    const result = [];
    const categories = dashboardData?.categories || {};

    for (const item in categories) {
      result.push({
        amount: categories[item].amount,
        title: t(categories[item].title),
        percent: categories[item].percent,
      });
    }

    return result;
  }, [dashboardData?.categories, t]);

  return (
    <CategoriesAnalytics categories={categories} isLoading={dataIsFetching} />
  );
};

export default withNamespaces()(DashboardCategories);
